import { Collection } from '../types/collection';

import { is } from '../util/is';
import { map } from '../collections/map';

/**
 * A value that can be sorted.
 */
type Ord = number | string;

/**
 * Takes a function of type `A -> Ord` and a [[Collection]] of type `F<A>` and returns a sorted array of type `A[]`.
 *
 * ```ts
 * ```
 *
 * @param fn Takes an argument of type `A` and returns a value of type [[Ord]] to be used for sorting.
 * @param c An array of sorted values.
 */
export function sortBy<A>(fn: (a: A) => Ord, c: A[]): A[];
export function sortBy<A>(fn: (a: A) => Ord, c: Record<string, A>): A[];
export function sortBy<A>(fn: (a: A) => Ord, c: Collection<A>): A[] {
  const arr: A[] = is(Array, c) ? (c as A[]) : map<string, A>((k) => (c as Record<string, A>)[k], Object.keys(c));

  return Array.prototype.slice.call(arr, 0).sort((a: A, b: A) => {
    const aa = fn(a);
    const bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
}
